/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.com>
 */
require(['jquery', 'jquery-ui/jquery-ui', 'bootstrap'], function(jQuery) {
    var bootstrapTooltip = jQuery.fn.tooltip.noConflict();
    jQuery.fn.bstooltip = bootstrapTooltip;
    var bootstrapButton = jQuery.fn.button.noConflict(); // return $.fn.button to previously assigned value
    jQuery.fn.bootstrapBtn = bootstrapButton;
    jQuery.noConflict();
});
